import { render } from "./StudentViewDemeritsDataTable.vue?vue&type=template&id=4a0ecfc8&scoped=true"
import script from "./StudentViewDemeritsDataTable.vue?vue&type=script&lang=js"
export * from "./StudentViewDemeritsDataTable.vue?vue&type=script&lang=js"

import "./StudentViewDemeritsDataTable.vue?vue&type=style&index=0&id=4a0ecfc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0ecfc8"]])

export default __exports__